<lib-chart-doughnut #ChartWrapper disableLegend [chartConf]="conf"/>